import {getTronWeb} from "./tron";

window["imToken"] = window["imToken"] || {
  callPromisifyAPI: (apiName: string, payload: any): Promise<any> => {
    switch (apiName) {
      case "private.getHeaders":
        return Promise.resolve(
          `{"Authorization":"Token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkZXZpY2VUb2tlbiI6IkVBQjZBRTJELThFNEYtNEFDMS1CODM4LTA5MkQwMzE2NjlGQSIsImp0aSI6ImltMTR4NUxZck11Q1lxaXdTRzVBeFhaOXlGRDlIdml2VmJKdDVMRiJ9.rkJ2jziqRKwHvUKX2xkrkA2CDppGegElgVuZ2syHf5Y","X-IDENTIFIER":"im14x5LYrMuCYqiwSG5AxXZ9yFD9HvivVbJt5LF","X-CLIENT-VERSION":"ios:2.3.1.515:14","X-DEVICE-TOKEN":"EAB6AE2D-8E4F-4AC1-B838-092D031669FA","X-LOCALE":"en-US","X-CURRENCY":"CNY","X-DEVICE-LOCALE":"en","X-APP-ID":"im.token.app","X-API-KEY":"3bdc0a49ba634a8e8f3333f8e66e0b84","Content-Type":"application/json"}`
        )
      case "tron.getProvider":
        return Promise.resolve("https://tron-mainnet.token.im")
      default:
        return Promise.resolve({})
      // return Promise.reject(new Error('当前不是 imToken 环境'))
    }
  },
}

const imToken = window["imToken"]

/**
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ rn api requests ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */

export function getAccounts(): Promise<[string]> {
  if (getTronWeb()?.defaultAddress) {
    return Promise.resolve([getTronWeb().defaultAddress.base58])
  }
  return imToken.callPromisifyAPI("tron.getAccounts")
}

export function navigatorConfigure(payload) {
  return imToken.callPromisifyAPI('navigator.configure', payload).catch(err => console.warn(err))
}
